var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dashboard-info"},[_c('div',{staticClass:"page-dashboard-info__form"},[_c('page-dashboard-info-user')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }